import {memo} from "react";
import {NodeProps} from "@xyflow/react";
import {Metric, TreeNode} from "@/types";
import {BasicCardNode, get_color, render_line} from "@/pages/mindmap/CarNodes/BasicCardNode.tsx";
import {COLOR_MAP} from "@/pages/mindmap/constant.ts";

export const PlatformNode = memo(({data}: NodeProps) => {
    const node: TreeNode = data.node as any;
    const datas: Record<string, Metric> = node.metrics_map || {};

    const get_child_novbp_datas = () =>{
        const child = node.children?.find(c => c.id.endsWith('-nonvbp'))
        return child?.metrics_map || {}
    }

    return <BasicCardNode node={node} showChart={true} data={data}>
        <div style={{fontSize: '10px', color: 'rgb(30, 41, 59)'}}>
            <span style={COLOR_MAP['1']}>IMS:</span>
            <div style={{marginLeft: '10px', lineHeight: '1.5'}}>
                {render_line('ims', 'ytd', datas)}
                {render_line('ims', 'mtd', datas)}
            </div>
            <br/>
            <span style={COLOR_MAP['1']}>NTS:</span>
            <div style={{marginLeft: '10px'}}>
                {render_line('nts', 'ytd', datas)}
                {render_line('nts', 'mtd', datas)}
                <br/>
            </div>
            <span style={COLOR_MAP['1']}>VBP/Non-VBP:</span>
            <div style={{marginLeft: '10px'}}>
                {render_line('ims_vbp', 'ytd', datas)}
                {render_line('ims_nonvbp', 'ytd', get_child_novbp_datas())}
            </div>
        </div>
    </BasicCardNode>
})